<template>
  <!-- 圆形头像容器，复用全局样式变量，自动跟随白天/夜间模式 -->
  <div 
    class="el-user-avatar"
    :style="{ width: size + 'px', height: size + 'px' }"
  >
    <!-- 显示用户名称（居中展示，继承全局字体样式） -->
    <span class="avatar-name">{{ user_display_name }}</span>
  </div>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    // 用户显示名称（必传属性）
    user_display_name: {
      type: String,
      required: true,
      default: ""
    },
    // 头像尺寸（可选，默认40px，支持自定义）
    size: {
      type: [Number, String],
      default: 40
    }
  }
};
</script>

<style scoped>
/* 通用头像容器样式（完全复用全局CSS变量，自动适配白天/夜间模式） */
.el-user-avatar {
  /* 核心：完美圆形 */
  border-radius: 50%;
  /* 弹性布局：文字水平垂直居中（兼容性拉满） */
  display: flex;
  align-items: center;
  justify-content: center;
  /* 复用全局字体样式：字体、行高 */
  font-family: var(--font-primary) !important;
  line-height: var(--line-height-base);
  font-size: var(--font-size);
  font-weight: 500;
  text-align: center;
  /* 复用全局颜色变量：背景+文字+边框，自动跟随白天/夜间切换 */
  background-color: var(--bg-front);
  color: var(--txt-color);
  border: 1px solid var(--label-border);
  /* 复用全局阴影变量，保持视觉风格统一 */
  box-shadow: 0 2px 8px var(--shadow-color);
  /* 防文字溢出：单行省略 */
  overflow: hidden;
  /* 过渡效果：模式切换/尺寸变化更顺滑 */
  transition: all 0.3s ease;
  /* 防止文字挤压，预留内边距 */
  padding: 0 2px;
}

/* 用户名称样式：继承全局样式，优化显示效果 */
.avatar-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* 文字间距优化，提升美观度 */
  letter-spacing: 0.5px;
  margin: 3px;
  font-size: 15px;
}

/* 尺寸变化时，同步调整文字大小，保持比例协调 */
/deep/ .el-user-avatar[style*="30px"] .avatar-name {
  font-size: 12px;
}
/deep/ .el-user-avatar[style*="60px"] .avatar-name {
  font-size: 18px;
}
/deep/ .el-user-avatar[style*="80px"] .avatar-name {
  font-size: 22px;
}

/* 可选：头像hover效果，复用全局hover变量，保持交互风格统一 */
.el-user-avatar:hover {
  /* border-color: var(--label-hover); */
  color: var(--label-hover);
  box-shadow: 0 4px 12px var(--shadow-color);
  cursor: default;
}
</style>